import React from "react";
import "./AnnouncementBar.scss"

const AnnouncementBar = ({ announcement }) => {
    // console.log(announcement);
    
  const storageKey = `announcement.dismissed.${announcement?.id}`;
  const [open, setOpen] = React.useState(() => {
    try {
      return localStorage.getItem(storageKey) !== "1";
    } catch {
      return true;
    }
  });

  const handleClose = () => {
    setOpen(false);
    try {
      localStorage.setItem(storageKey, "1");
    } catch {}
  };

  if (!open || !announcement?.msg) return null;

  return (
    <div className="announcement-bar">
      <div className="announcement-inner">
        <div className="announcement-text">{announcement?.msg}</div>
        <button
          type="button"
          className="announcement-close"
          aria-label="Dismiss announcement"
          onClick={handleClose}
        >
          ✕
        </button>
      </div>
    </div>
  );
};

export default AnnouncementBar;
